import Vue from 'vue'
import App from './App.vue'
import firebase from "firebase/app";
import "firebase/analytics";

import './registerServiceWorker'
import router from './router'
import store from './store'
import Buefy from 'buefy'
import Notifications from 'vue-notification'
import '@/assets/theme.scss';
import 'nprogress/nprogress.css';
import vueAwesomeCountdown from 'vue-awesome-countdown'


Vue.config.productionTip = false
Vue.use(Buefy);
Vue.use(Notifications);
Vue.use(vueAwesomeCountdown, 'vac')

const firebaseConfig = {
  apiKey: "AIzaSyA96yiJi12vuYpjPaKWZOeO7xhg8syq3bE",
  authDomain: "tambola-475ae.firebaseapp.com",
  projectId: "tambola-475ae",
  storageBucket: "tambola-475ae.appspot.com",
  messagingSenderId: "486486986394",
  appId: "1:486486986394:web:2dbefcddd46896d1a01923",
  measurementId: "G-C4NDFFR6R0"
};
// Initialize Firebase
firebase.initializeApp(firebaseConfig);
firebase.analytics();

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
